import { createFileRoute } from '@tanstack/react-router'
import { QrScansScreen } from '@/components/analytics/qr-scans-screen'
import { RowsSkeleton } from '@/components/shell/screen-skeletons'
import { requireAnalyticsAccess } from '@/lib/queries/analytics-access'

export const Route = createFileRoute('/o/$org/qr-codes/$id/scans')({
  beforeLoad: ({ context: { queryClient }, params: { org } }) =>
    requireAnalyticsAccess({ queryClient, orgSlug: org }),
  pendingComponent: RowsSkeleton,
  component: QrScansRoute,
})

function QrScansRoute() {
  const { id } = Route.useParams()
  return <QrScansScreen constellationId={id} />
}
